<template>
  <div>
    <div class="mailingInfo">Mailing info: </div>
      <a-form :form="editForm" @submit="handleSubmit" autocomplete="off">
        <a-row :gutter="10" class="addressBox">
          <a-col :xs="24" :lg="4">
            <!-- 国家 -->
            <a-form-item label="Country">
              <a-select
                :showSearch="true"
                optionFilterProp="children"
                @change="handelCountryChange"
                v-decorator="[
                  'addressData.countryId',
                  { rules: [{ required: false, message: 'Please select your country!' }] },
                ]"
              >
                <!-- <a-select-option :value="''">N/A</a-select-option> -->
                <a-select-option v-for="i in countryList" :key="'country-' + i.id" :value="i.id">{{ i.nameEnUs }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="8">
            <!-- 地址 -->
            <a-form-item label="Address">
              <a-textarea
                v-decorator="[
                  'addressData.detail',
                  {rules: [{ required: false, message: 'Please input your address.' }]}
                ]"
                auto-size
              />
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="4">
            <!-- 城市 -->
            <a-form-item label="City">
              <a-input
                v-decorator="[
                  'addressData.cityInput',
                  {rules: [{ required: false, message: 'Please input your city.' }]}
                ]"
              ></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="4" v-show="false">
            <!-- 城市 -->
            <a-form-item label="City">
              <a-select
                :showSearch="true"
                optionFilterProp="children"
                v-decorator="[
                  'addressData.cityId',
                  { rules: [{ required: false, message: 'Please select your City!' }] },
                ]"
              >
                <a-select-option :value="''">N/A</a-select-option>
                <a-select-option v-for="c in cityList" :key="'city-' + c.id" :value="c.id">{{ c.nameEnUs }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="4">
            <!-- 州 -->
            <a-form-item label="State/Province">
              <a-select
                :showSearch="true"
                optionFilterProp="children"
                v-decorator="[
                  'addressData.stateId',
                  { rules: [{ required: false, message: 'Please select your state!' }] },
                ]"
                @change="handelStateChange"
              >
                <!-- <a-select-option :value="''">N/A</a-select-option> -->
                <a-select-option v-for="s in stateList" :key="'state-' + s.id" :value="s.id">{{ s.nameEnUs }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :lg="4">
            <!-- 邮编 -->
            <a-form-item label="Zip">
              <a-input
                v-decorator="[
                  'addressData.zipcode',
                  {rules: [{ required: false, message: 'Please input your zipCode.' }]}
                ]"
                ></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import CountryApi from '@/api/basicdata/api-country'
import CityApi from '@/api/basicdata/api-city'
import StateApi from '@/api/basicdata/api-state'
import RouteView from '@/components/layouts/RouteView.vue'

export default {
  name: 'CdbCustomerAddress',
  components: {
    RouteView
  },
  props: {
    initData: {
      type: [Array],
      default: null
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 24 }
        }
      },
      editForm: this.$form.createForm(this),
      visible: false,
      countryList: [],
      cityList: [],
      stateList: [],
      datas: this.initData,
      addressData: null
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    async loadData() {
      const countryListRes = await CountryApi.list()
      this.countryList = countryListRes.data
      const addressList = this.initData
      let addressData = null
      if (!addressList || addressList.length == 0) {		
        addressData = { detail: null, cityId: '', countryId: '', stateId: '', zipcode: null, cityInput:null }
      } else {
        addressData = addressList[0]
        if (addressData.countryId) {
          const stateListRes = await StateApi.list(addressData.countryId)
          this.stateList = this.sortStateList(stateListRes.data)
        }
        if (addressData.stateId) {
          const cityListRes = await CityApi.listByState(addressData.stateId)
          this.cityList = cityListRes.data
        }
      }
      this.addressData = addressData
      const formData = {}
      formData.addressData = pick(addressData, ['countryId', 'detail', 'cityInput', 'cityId', 'stateId', 'zipcode'])
      this.editForm.setFieldsValue(formData)
    },
    // 处理国家选项变化
    async handelCountryChange (countryId) {
      if (!countryId) {
        this.stateList = []
        this.cityList = []	  
      }
      const stateListRes = await StateApi.list(countryId)
      this.stateList = this.sortStateList(stateListRes.data)
      this.cityList = []
      this.editForm.setFieldsValue({addressData: { cityId: '', stateId: '', detail: null, zipcode: null, cityInput: null }})
    },
    // 监控地址里的州变化
		async handelStateChange (stateId) {
      if (!stateId) {
        this.cityList = []
      }
      const cityListRes = await CityApi.listByState(stateId)
      this.cityList = cityListRes.data
      const formData = this.editForm.getFieldsValue()
      const addressData = formData.addressData
      addressData.cityId = null
      formData.addressData = addressData
      this.editForm.setFieldsValue({addressData: { cityId: '' }})
    },
    handleSubmit (e) {
      e.preventDefault()
    },
    // 给州列表排序
		sortStateList (stateList) {
      if (stateList && stateList.length > 0) {
        const newList = stateList.sort((a, b) => {
          return a.nameEnUs > b.nameEnUs ? 1 : -1
        })
        return newList
      } else {
        return stateList
      }
    },
    // 父组件获取数据
    getAddressList () {
      const formdata = this.editForm.getFieldsValue()
      const addressList = []
      addressList.push(formdata.addressData)
      return addressList
    }
  },
  watch: {
    initData (newDatas) {
      this.datas = newDatas
      this.loadData()
    }
  }
}
</script>
<style lang="less" scoped>
.mailingInfo {
  color: #000;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
}
.addressBox ::v-deep .ant-form-item-label > label::after {
	content: "";
}
</style>
